// Coarse device bucket from the user agent, ported from our other properties so the
// values line up across projects: 'smart tv' | 'mobile' | 'tablet' | 'desktop'.
// The UA is lowercased first so the regex `i` flags are redundant, but they're kept
// to match the source verbatim.
export default function getDeviceType() {
    const ua = navigator.userAgent.toLowerCase();

    if (/(smart[-\s]?tv|googletv|appletv|hbbtv|netcasttv|webostv|tizen)/i.test(ua)) {
        return 'smart tv';
    }

    if (/mobi|android|iphone|ipad|ipod|windows phone|blackberry/i.test(ua)) {
        if (/tablet|ipad/i.test(ua)) {
            return 'tablet';
        }
        return 'mobile';
    }

    if (/tablet|ipad|playbook/i.test(ua) || /android(?!.*mobi)/i.test(ua)) {
        return 'tablet';
    }

    return 'desktop';
}
